module.exports = __webpack_public_path__ + "img/print.b780bbf2.svg";